import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import JSConfetti from 'js-confetti';
import s from './EmojiConfetti.module.css';

const EmojiConfetti = ({ className, emojis = ['🎉'] }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (canvasRef.current) {
      const confetti = new JSConfetti({ canvas: canvasRef.current });
      confetti.addConfetti({ emojis });
    }
  }, [emojis]);

  return (
    <canvas
      ref={canvasRef}
      className={className || s.confettiCanvas}
      aria-hidden="true"
    />
  );
};

EmojiConfetti.propTypes = {
  className: PropTypes.string,
  emojis: PropTypes.arrayOf(PropTypes.string),
};

export default EmojiConfetti;
